/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isuserallowedtotogglemic5Inputs */

const en_entity_isuserallowedtotogglemic5 = /** @type {(inputs: Entity_Isuserallowedtotogglemic5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is User Allowed To Toggle Mic`)
};

const de_entity_isuserallowedtotogglemic5 = /** @type {(inputs: Entity_Isuserallowedtotogglemic5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer darf Mikrofon umschalten`)
};

/**
* | output |
* | --- |
* | "Is User Allowed To Toggle Mic" |
*
* @param {Entity_Isuserallowedtotogglemic5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isuserallowedtotogglemic5 = /** @type {((inputs?: Entity_Isuserallowedtotogglemic5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isuserallowedtotogglemic5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isuserallowedtotogglemic5(inputs)
	return de_entity_isuserallowedtotogglemic5(inputs)
});
export { entity_isuserallowedtotogglemic5 as "entity_isUserAllowedToToggleMic" }